import { Link } from "react-router-dom";

export interface EventData {
  slug: string;
  title: string;
  subtitle: string;
  dateRange: string;
  startDate: string;
  endDate: string;
  location: string;
  locationDetail: string;
  type: "retreat" | "satsang" | "workshop" | "online";
  status: "upcoming" | "open" | "sold-out" | "past";
  heroEmoji: string;
  excerpt: string;
  tags: string[];
  minPrice: number | null; // null = free/PWYC
}

export const EVENTS_DATA: EventData[] = [
  {
    slug: "astral-healing-retreat-2026",
    title: "Astral Healing: 2-Day Retreat",
    subtitle: "A transformative immersive experience in sacred natural surroundings",
    dateRange: "May 29–31, 2026",
    startDate: "2026-05-29",
    endDate: "2026-05-31",
    location: "The Grand Oaks Resort",
    locationDetail: "Weirsdale, FL 32195",
    type: "retreat",
    status: "open",
    heroEmoji: "🌿",
    excerpt:
      "Immerse yourself in two days of guided meditation, astral awareness practices, yoga, and satsang in the serene landscapes of central Florida. Limited spots available.",
    tags: ["Meditation", "Astral", "Retreat", "Yoga", "Satsang"],
    minPrice: 0,
  },
  {
    slug: "weekly-satsang",
    title: "Weekly Online Satsang",
    subtitle: "Live community wisdom circle — every Sunday",
    dateRange: "Every Sunday",
    startDate: "2026-04-26",
    endDate: "",
    location: "Online (Zoom)",
    locationDetail: "Link sent after registration",
    type: "online",
    status: "open",
    heroEmoji: "📿",
    excerpt:
      "Join our weekly live satsang for meditation, Q&A with teachers, and community connection. Free and open to all seekers.",
    tags: ["Satsang", "Online", "Free", "Weekly"],
    minPrice: 0,
  },
  {
    slug: "meditation-intensive-summer-2026",
    title: "Summer Meditation Intensive",
    subtitle: "Seven days of deepening silence and inner inquiry",
    dateRange: "July 10–17, 2026",
    startDate: "2026-07-10",
    endDate: "2026-07-17",
    location: "TBA",
    locationDetail: "Location to be announced",
    type: "retreat",
    status: "upcoming",
    heroEmoji: "🧘",
    excerpt:
      "A seven-day residential intensive focused on samatha and vipassana meditation. Open to practitioners with at least 6 months of consistent practice.",
    tags: ["Meditation", "Intensive", "Residential", "Advanced"],
    minPrice: 108,
  },
];
